import { render, staticRenderFns } from "./DownloadUser.vue?vue&type=template&id=97800694&"
import script from "./DownloadUser.vue?vue&type=script&lang=js&"
export * from "./DownloadUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports